import { render, staticRenderFns } from "./BookingRepx.vue?vue&type=template&id=28e01574"
import script from "./BookingRepx.vue?vue&type=script&lang=js"
export * from "./BookingRepx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28e01574')) {
      api.createRecord('28e01574', component.options)
    } else {
      api.reload('28e01574', component.options)
    }
    module.hot.accept("./BookingRepx.vue?vue&type=template&id=28e01574", function () {
      api.rerender('28e01574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/booking/BookingRepx.vue"
export default component.exports